import {
  LayoutBar,
  LayoutPane,
  LayoutSlideIn,
  LayoutModal as LayoutVariationModal
} from './variations';
import type { LayoutVariationProps } from './variations/types';

// Bar
function LayoutVariationTopBar(props: LayoutVariationProps) {
  return <LayoutBar {...props} position="top" />;
}

function LayoutVariationBottomBar(props: LayoutVariationProps) {
  return <LayoutBar {...props} position="bottom" />;
}

// Pane
function LayoutVariationLeftPane(props: LayoutVariationProps) {
  return <LayoutPane {...props} position="left" />;
}

function LayoutVariationRightPane(props: LayoutVariationProps) {
  return <LayoutPane {...props} position="right" />;
}

// Slide In
function LayoutVariationLeftSlideIn(props: LayoutVariationProps) {
  return <LayoutSlideIn {...props} position="bottom-left" />;
}

function LayoutVariationRightSlideIn(props: LayoutVariationProps) {
  return <LayoutSlideIn {...props} position="bottom-right" />;
}

export function Layout(props: LayoutVariationProps) {
  const layoutVariationMap = {
    modal: LayoutVariationModal,

    leftPane: LayoutVariationLeftPane,
    rightPane: LayoutVariationRightPane,

    slideInLeft: LayoutVariationLeftSlideIn,
    leftSlideIn: LayoutVariationLeftSlideIn,

    rightSlideIn: LayoutVariationRightSlideIn,
    slideInRight: LayoutVariationRightSlideIn,

    topBar: LayoutVariationTopBar,
    bottomBar: LayoutVariationBottomBar
  };
  const LayoutVariationComponent = layoutVariationMap[props.variation];

  return <LayoutVariationComponent {...props} />;
}
